const message = ({ layout }) => layout?.snackbar?.message;
const opened = ({ layout }) => layout?.snackbar?.open;

export { message, opened };
